import { render, staticRenderFns } from "./robotBeds.vue?vue&type=template&id=77b11e6a&"
import script from "./robotBeds.vue?vue&type=script&lang=js&"
export * from "./robotBeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b11e6a')) {
      api.createRecord('77b11e6a', component.options)
    } else {
      api.reload('77b11e6a', component.options)
    }
    module.hot.accept("./robotBeds.vue?vue&type=template&id=77b11e6a&", function () {
      api.rerender('77b11e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/medical/robot/robotBeds.vue"
export default component.exports